import { isTruthy } from "@dashboard/library";

import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";
import { useBaseStore } from "@/store/store";

import {
  GetTagsAndNotesQuery,
  GetTagsAndNotesQueryVariables,
} from "@/graphql/generated/graphql";
import { GetTagsAndNotes } from "@/graphql/queries/GetTagsAndNotes";
import { UseGetTagsAndNotesArgs } from "./useGetTagsAndNotes.decl";

export function useGetTagsAndNotes({ callId }: UseGetTagsAndNotesArgs) {
  const setActiveTags = useBaseStore((store) => store.setActiveTags);
  const { data, loading } = useQueryWrapper<
    GetTagsAndNotesQuery,
    GetTagsAndNotesQueryVariables
  >(GetTagsAndNotes, {
    variables: {
      callId,
    },
    onCompleted: (data) => {
      setActiveTags((data.getTagsAndNotes?.tags ?? []).filter(isTruthy));
    },
  });

  return {
    loading,
    tags: data?.getTagsAndNotes?.tags.filter(isTruthy) ?? [],
    notes: data?.getTagsAndNotes?.notes.filter(isTruthy) ?? [],
  };
}
